"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ThePinnacleHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="229859" id="setting-the-standard-in-media-strategy" className="bg-background text-foreground relative flex min-h-screen w-full items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661389/img/abstract_data_nodes_cityscape.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/90 to-background/60 md:bg-gradient-to-r md:from-background md:via-background/80 md:to-transparent backdrop-blur-[2px]" />
      </div>

      {}
      <div ref={ref} className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-start justify-center px-6 py-24 md:px-12">
        <h1 className={`font-default text-foreground max-w-4xl text-6xl font-bold leading-[0.9] tracking-tighter sm:text-7xl md:text-8xl lg:text-[8rem] transition-all duration-1000 ease-out bg-gradient-to-b from-white to-slate-400 bg-clip-text text-transparent ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          SETTING THE STANDARD
        </h1>

        <div className={`transition-all duration-1000 ease-out delay-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Separator className="bg-primary my-8 h-[2px] w-24 md:my-12 shadow-[0_0_15px_rgba(45,91,255,0.5)]" />
        </div>

        <p className={`font-mono text-muted-foreground max-w-md text-lg font-light leading-relaxed md:text-xl transition-all duration-1000 ease-out delay-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <span className="text-primary font-semibold">DATA-DRIVEN DOMINANCE.</span> Elevate your brand presence with architectural precision and elite media strategy.
        </p>

        <div className={`mt-12 transition-all duration-1000 ease-out delay-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 group relative h-14 overflow-hidden rounded-sm border-none px-10 text-lg font-medium shadow-2xl transition-all hover:shadow-primary/40">
            <Link to="/SolutionsPage">
              <span className="relative z-10 flex items-center">
                View Solutions
                <ArrowRight className="ml-3 size-5 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
              {}
              <div className="absolute inset-0 z-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent" style={{
              animation: "shimmer 5s infinite"
            }} />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            15% { transform: translateX(100%); }
            100% { transform: translateX(100%); }
          }
        `
    }} />
    </section>;
}